import Table from 'emerald-ui/lib/Table';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Table, componentName: 'Table' }], 'Table'),
  description: 'A Table is used to display data in an orderly an classic tabular fashion.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Table },
      code: `<div style={{ overflow: 'auto' }}>
  <Table>
    <thead>
      <tr>
        <th>Name</th>
        <th>Role</th>
        <th>Group</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>John Doe</td>
        <td>Administrator</td>
        <td>Group 1</td>
      </tr>
      <tr>
        <td>John Appleseed</td>
        <td>Manager</td>
        <td>Group 1</td>
      </tr>
      <tr>
        <td>Jane Doe</td>
        <td>Manager</td>
        <td>Group 2</td>
      </tr>
    </tbody>
  </Table>
</div>`,
    },
  ],
};
